import React from 'react';
import { Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';

import {
  openAuthorizePopup,
  redirectToAuthorize,
  rememberPendingNumber,
} from '../../lib/ringcentral/auth';

// THE RingCentral login prompt (Nic 2026-08-22): one modal, rendered
// verbatim by every surface that needs an RC session — the call dialer and
// the text composer today. Extracted pixel-for-pixel from RcCallModal's
// needsAuth state so nothing about the dialer's look changed.
//
// Popup first: the redirect flow drops the whole page (open panels, drafts)
// for a login the popup handles in place. Redirect survives only as the
// popup-blocked fallback, with the pending-number recovery the dialer
// always had (pass `pendingNumber` to arm it).
//
// The Modal passthroughs (style/className/dialogClassName/enforceFocus/
// backdrop) exist because the board layers the dialer OVER its slide-over
// with a lifted z-index — this modal must honor the same layering when it
// stands in for the dialer.
const RcLoginModal = ({
  show,
  onHide,
  onLoggedIn,
  pendingNumber,
  note,
  backdrop = 'static',
  style,
  className,
  dialogClassName,
  enforceFocus = true,
}) => (
  <Modal
    show={show}
    onHide={onHide}
    backdrop={backdrop}
    centered
    style={style}
    className={className}
    dialogClassName={dialogClassName}
    enforceFocus={enforceFocus}
  >
    <Modal.Header closeButton className="border-0 pb-0">
      <Modal.Title className="d-flex align-items-center">
        <FontAwesomeIcon icon={faPhone} className="text-slate-400" />
      </Modal.Title>
    </Modal.Header>
    <Modal.Body className="p-0">
      <div className="flex flex-col items-center gap-4 px-5 pb-6 pt-4">
        <p className="mb-0 text-center text-sm text-slate-600 dark:text-slate-300">
          Please login to RingCentral to place calls and send texts.
        </p>
        {note ? (
          <p className="-mt-2 mb-0 text-center text-xs text-slate-400 dark:text-slate-500">
            {note}
          </p>
        ) : null}
        <button
          type="button"
          onClick={async () => {
            try {
              const ok = await openAuthorizePopup();
              if (ok) {
                onLoggedIn?.();
                return;
              }
              if (pendingNumber) rememberPendingNumber(pendingNumber);
              await redirectToAuthorize();
            } catch (e) {
              toast.error(e.message || 'Could not start RingCentral login');
            }
          }}
          className="rounded-lg bg-slate-900 px-4 py-2 text-sm font-semibold text-white hover:bg-slate-700 dark:bg-slate-200 dark:!text-slate-900 dark:hover:bg-slate-100"
        >
          Login to RingCentral
        </button>
      </div>
    </Modal.Body>
  </Modal>
);

export default RcLoginModal;
